export const getChatBotAgentId = (env) => {
  switch (env) {
    case 'production':
    case 'au_production':
      return process.env.REACT_APP_PROD_AGENT_ID;

    case 'stage':
    case 'au_stage':
    default:
      return process.env.REACT_APP_STAGE_AGENT_ID;
  }
};
